import React, { useContext } from "react";
import { DataContext } from "../components/DataProvider";
import { FaPoundSign } from "react-icons/fa";

const Results = () => {
  const { formData } = useContext(DataContext);

  const { amount, interestRate, years } = formData;
  const r = interestRate / 12;
  const n = years * 12;
  const monthlyPayment = (
    (amount * (r * (1 + r) ** n)) /
    ((1 + r) ** n - 1)
  ).toPrecision(8);

  const totalAmountPaid = monthlyPayment * n;

  return (
    <>
      <div className="container shadow-lg shadow-indigo-700  bg-purple-800 border sm:max-w-sm w-full sm:max-h-[520px]">
        {formData.isSetData === false ? (
          <div className="flex flex-col text-white gap-5 py-10 items-center">
            <img src="./illustration-empty.svg" alt="illustration" />
            <h1 className="text-2xl text-center font-semibold">
              Results shown here
            </h1>
            <p className="font-light text-center max-w-80 text-sm">
              Complete the form and click "calculate repayments" to see what
              your monthly payments would be.
            </p>
          </div>
        ) : (
          <>
            <div className=" mt-5 p-4">
              <h1 className="text-2xl  text-white font-semibold">
                Your Results
              </h1>
              <p className="font-light p-4 text-justify text-white max-w-80 text-sm">
                Your results are shown based on the information you provided. To
                adjust the results, edit the form and click 'Calculate
                Repayments' again.
              </p>
              <div className=" flex flex-col gap-4 shadow-lg shadow-yellow-800 bg-gray-800 p-5 text-white border border-t-8 rounded-lg border-yellow-500 mt-10  max-w-auto ">
                <h2 className="font-light text-sm">Your monthly repayments</h2>
                <h2 className=" text-4xl inline-flex text-yellow-500 font-bold">
                  <FaPoundSign size={40} /> {monthlyPayment}
                </h2>
                <hr className=" mt-5"></hr>
                <p className="font-light text-white max-w-80 text-sm">
                  Total you will repay over the term.
                </p>
                <h3 className=" font-bold inline-flex text-white text-2xl">
                  <FaPoundSign size={30} /> {parseInt(totalAmountPaid)}
                </h3>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Results;
